import React, { useMemo } from "react";
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight } from "react-icons/fa";

interface PaginationType {
  total: number;
  page: number;
  pageSize: number;
  className?: string;
  // eslint-disable-next-line no-unused-vars
  onChangePage?: ({ page, pageSize }: { page: number; pageSize: number }) => any;
  style?: Object;
}

export function Pagination({
  total,
  page = 1,
  pageSize = 20,
  className,
  onChangePage = () => {},
  style,
}: PaginationType) {
  const totalPage = Math.ceil(total / pageSize);

  const handleChange = (p: number) => {
    onChangePage({ page: p, pageSize });
  };

  const pages = Array.from(Array(totalPage).keys());

  const pagination = useMemo(() => {
    let startAt = 0;
    let endAt = 5;

    if (page >= totalPage - 5) {
      startAt = totalPage - 10;
      endAt = totalPage - 5;
    } else if (page > 3) {
      startAt = page - 3;
      endAt = page + 3;
    }

    return { startAt, endAt };
  }, [page, totalPage]);

  return total ? (
    <div className={className} style={style}>
      <nav className="inline-flex rounded-md shadow-sm -space-x-px bg-red-400" aria-label="Pagination">
        <button
          className="inline-flex items-center px-3 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
          onClick={() => {
            if (page > 1) {
              handleChange(1);
            }
          }}
          disabled={page === 1}
        >
          <FaAngleDoubleLeft />
        </button>
        <button
          className="inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
          onClick={() => {
            if (page > 1) {
              handleChange(page - 1);
            }
          }}
          disabled={page === 1}
        >
          <FaAngleLeft />
        </button>
        {totalPage > 10 ? (
          <div>
            {pages.slice(pagination.startAt, pagination.endAt).map((i) => {
              const p = i + 1;

              return (
                <button
                  key={p}
                  aria-current="page"
                  className={`${
                    page === p
                      ? " bg-indigo-50 border-indigo-500 text-indigo-600"
                      : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50 "
                  } inline-flex items-center px-4 py-2 border text-sm font-medium`}
                  onClick={() => handleChange(p)}
                >
                  {p}
                </button>
              );
            })}
            <span className="inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">
              ...
            </span>
            {pages.slice(totalPage - 5, totalPage).map((i) => {
              const p = i + 1;

              return (
                <button
                  key={p}
                  aria-current="page"
                  className={`${
                    page === p
                      ? " bg-indigo-50 border-indigo-500 text-indigo-600"
                      : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50 "
                  }  inline-flex items-center px-4 py-2 border text-sm font-medium`}
                  onClick={() => handleChange(p)}
                >
                  {p}
                </button>
              );
            })}
          </div>
        ) : (
          pages.map((i) => {
            const p = i + 1;
            return (
              <button
                key={p}
                aria-current="page"
                className={`${
                  page === p
                    ? "z-10 bg-indigo-50 border-indigo-500 text-indigo-600"
                    : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50 "
                }  inline-flex items-center px-4 py-2 border text-sm font-medium`}
                onClick={() => handleChange(p)}
              >
                {p}
              </button>
            );
          })
        )}

        <button
          className=" inline-flex items-center px-2 py-2  border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
          onClick={() => {
            if (page < totalPage) {
              handleChange(page + 1);
            }
          }}
          disabled={page === totalPage}
        >
          <FaAngleRight />
        </button>
        <button
          className=" inline-flex items-center px-3 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
          onClick={() => {
            if (page < totalPage) {
              handleChange(totalPage);
            }
          }}
          disabled={page === totalPage}
        >
          <FaAngleDoubleRight />
        </button>
      </nav>
    </div>
  ) : (
    <div></div>
  );
}
